import React from "react"
import PropTypes from "prop-types"
import IconButton from "@material-ui/core/IconButton"
import Tooltip from "@material-ui/core/Tooltip"
import useSmartFormat from "../../i18n/useSmartFormat"

const TooltipIconButton = (props) => {
  const { label, children, ...args } = props
  const format = useSmartFormat()
  const localizedLabel = format(label)

  return (
    <Tooltip title={localizedLabel}>
      <span>
        <IconButton {...args}>{children}</IconButton>
      </span>
    </Tooltip>
  )
}

TooltipIconButton.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string.isRequired
    })
  ]).isRequired
}

TooltipIconButton.defaultProps = {
  classes: undefined
}

export default TooltipIconButton
